import type {InterestSignalPolicy} from '../types/InterestSignalPolicy';
import {INTEREST_SIGNAL_CODES} from './INTEREST_SIGNAL_CODES';

const DEFAULT_INTEREST_NO_FIRST_RESPONSE_MINIMUM_HOURS = 1;

const DEFAULT_INTEREST_COLD_THRESHOLD_DAYS = 7;

const DEFAULT_INTEREST_AWAITING_REPLY_MINIMUM_HOURS = 4;

export const DEFAULT_INTEREST_SIGNAL_POLICY: InterestSignalPolicy = {
  coldThresholdDays: DEFAULT_INTEREST_COLD_THRESHOLD_DAYS,
  awaitingReplyMinimumHours: DEFAULT_INTEREST_AWAITING_REPLY_MINIMUM_HOURS,
  noFirstResponseMinimumHours: DEFAULT_INTEREST_NO_FIRST_RESPONSE_MINIMUM_HOURS,
  enabledSignalCodes: INTEREST_SIGNAL_CODES,
};
